module.exports = __webpack_public_path__ + "fonts/YesevaOne-Regular.woff!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/YesevaOne-Regular.woff
// module id = 49
// module chunks = 0